var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2397"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2397"
    },
    "bundlingPackage": "video-player-ui",
    "bundlingPackageVersion": "static-1.36683",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};